import React, { useContext, useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { FaUsers } from 'react-icons/fa';
import InfoCamp from '../components/InfoCamp';
import SearchContainer from '../components/SearchContainer';
import AppContext from '../api/AppContext';

function Associados() {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const { associados, fetchAssociados } = useContext(AppContext);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    fetchAssociados();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filteredAssociados = associados.filter(obj =>
    obj.NOME.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    if (searchQuery === "") {
      fetchAssociados();
    }
  }, [searchQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  const totalPages = Math.ceil(filteredAssociados.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredAssociados.slice(startIndex, startIndex + itemsPerPage);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      fetchAssociados(searchQuery);
      setCurrentPage(1);
    }
  };

  return (
    <Layout title="Associados" icon={FaUsers}>
      <div style={isMobile ? styles.mobileContainer : styles.desktopContainer}>
        <SearchContainer 
          placeholder="Buscar associado..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <div style={styles.listaContainer}>
          {currentItems.map((ass, index) => (
            <InfoCamp 
              key={index} 
              associado={ass} 
              showDependentes={true} // Mostrar botão de dependentes
              showExtratoLanchonete={false} // Esconder botão de extrato lanchonete
              buttonStyle={styles.buttonStyle} // Estilo consistente para os botões
            />
          ))}
        </div>

        {totalPages > 1 && (
          <div style={styles.paginationContainer}>
            <button 
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} 
              disabled={currentPage === 1}
              style={styles.paginationButton}
            >
              Anterior
            </button>
            <span style={styles.pageInfo}>Página {currentPage} de {totalPages}</span>
            <button 
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} 
              disabled={currentPage === totalPages}
              style={styles.paginationButton}
            >
              Próxima
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}

const styles = {
  mobileContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '100%',
    gap: '20px'
  },
  desktopContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    width: '100%',
    maxWidth: '800px',
    margin: '0 auto',
    gap: '20px'
  },
  listaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    width: '100%'
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
    marginTop: '20px'
  },
  paginationButton: {
    backgroundColor: '#2563EB',
    color: '#fff',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  pageInfo: {
    fontWeight: 'bold',
    color: '#374151'
  },
  buttonStyle: {
    backgroundColor: '#2563EB',
    color: 'white',
    padding: '8px 16px',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginLeft: 'auto' // Isso fará com que o botão de gerar senha fique à direita
  }
};

export default Associados;